import type { TSiteFeature } from 'api/siteFeatures';
import type { FilterType } from 'store/FilterStore/types';
import { SiteFeaturesIDs } from 'store/SiteFeatures/SiteFeatures';
import type { LoadType } from 'types/cargosApp/Load';

type TFilterMode = {
  type: 'include' | 'exclude';
};

type TModeKey = 'loggingTruck' | 'roundTrip' | 'permanentCargoApplications';

type TLoadAttributes = {
  krugoreis?: boolean;
  truck?: { koniki?: boolean };
  loading?: { dateType?: number };
};

const permanentDateType = 2;

const attributeMatchers: Record<TModeKey, (load: TLoadAttributes) => boolean> = {
  loggingTruck: load => Boolean(load.truck?.koniki),
  roundTrip: load => Boolean(load.krugoreis),
  permanentCargoApplications: load => load.loading?.dateType === permanentDateType,
};

const modeKeys = Object.keys(attributeMatchers) as TModeKey[];

const applyReverseFiltersMock = (loads: LoadType[], filter: FilterType, siteFeatures: TSiteFeature) => {
  if (!siteFeatures[SiteFeaturesIDs.reverseFilters] || !siteFeatures[SiteFeaturesIDs.reverseFiltersMock]) return loads;

  const modes = filter as FilterType & Partial<Record<TModeKey, TFilterMode>>;

  return loads.filter(load =>
    modeKeys.every(key => {
      const mode = modes[key];

      if (!mode) return true;

      const hasAttribute = attributeMatchers[key](load as LoadType & TLoadAttributes);

      return mode.type === 'exclude' ? !hasAttribute : hasAttribute;
    }),
  );
};

export { applyReverseFiltersMock };
